import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import swal from 'sweetalert2';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { NgForm } from '@angular/forms';
import { WindowRef } from '../../shared/windowRef.service';

@Component({
  selector: 'app-form-application',
  templateUrl: './form-application.component.html',
  styleUrls: ['./form-application.component.css'],
  providers: [WindowRef]
})
export class FormApplicationComponent implements OnInit {
  @ViewChild('ApplicationForm') ApplicationForm: NgForm;
  // terms: boolean = false;
  isCasteRequired: boolean = true;
  flatType: string = '';
  applicantNameEnglish: string = '';
  applicantNameHindi: string = '';
  APP_SA_Name: string = '';
  coApplicantNameHindi: string = '';
  responseData: any;
  data: any;
  data1: any = {};
  branch: any = {};
  r: any = {};
  app: any = {};
  co_Village_Mohalla: string;
  co_Police_Station: string;
  applicantAffidavit: string;
  APP_Secondary_Affidavit: string;
  Relations: any;
  APP_PA_Age: any;
  Co_Pancard: string;
  Categories: any;
  f: any = {};
  Districts: any;
  District: any;
  Districtlist: any;
  Districtlists: any;
  fileToUpload: File = null;
  listDistrict: any;
  formInvalid: boolean;
  NO_Id: any;
  PD_Id: any;
  PD: any;
  pdId: any;
  role: any;
  id: any;
  APP_SA_Age: any;
  APP_SA_DOB: string;
  manifesto_sig_sec: string;
  DI_Id: any;
  Mobile_No: any;
  Bank_Branch: any;
  CA_Id: any;
  CA_Id_Fk: any;
  Banks: any;
  NO_Date: any;
  pay_formData: any;
  pay_data: any;
  DSWOId_NORF_ID_Amount: any;
  DSWOId_NORF_Amount: any;
  transactionId: any;
  paymentStatus: any;
  Online_Payment_Date: any;
  transid : any;
  paydate :any;
  payinfo : any;
  paymentStatusappfee: any;
  paymentStatusIDamount: any;
  NotificationPropertyType: string;
 hasClickedPay = false;
 hasClickedPayId = false;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler, winRef: WindowRef) {
    this.app.APP_IsJoint = 'N';
  }

  ngOnInit() {
     console.log("📢 ngOnInit in LoginComponent");
     console.log(this.paymentStatusappfee);
    window.addEventListener("message", this.receivePaymentMessage.bind(this), false);
    console.log("✅ Message listener added.");
    this.route.queryParams.subscribe(params => {
      this.id = params['id'];
      this.pdId = params['pdId'];
      this.role = params['role'];
    });
    this.route.queryParams.subscribe(params => {
      if (params['data']) {

        this.responseData = params['data'];
        console.log('Received response data: ', this.responseData);
        // Use responseData as needed in your component
      }
    });

    // const urlParams = new URLSearchParams(window.location.search);
     
    //   this.transactionId = urlParams.get('txnid') || '';
    //   this.paymentStatus = urlParams.get('status') || '';
    //   this.Online_Payment_Date = urlParams.get('addedon') || '';

     
    const urlParams = new URLSearchParams(window.location.search);
     
      this.transid = urlParams.get('txnid') || '';
      this.paymentStatus = urlParams.get('status') || '';
      this.paydate = urlParams.get('addedon') || '';
      this.payinfo = urlParams.get('productinfo') || '';

      if(this.payinfo == 'Applicant-Application-Fee') {
        this.app.Appfee_Transaction_Id = this.transid;
        this.app.Appfee_Payment_Date = this.paydate;
        this.paymentStatusappfee = this.paymentStatus;
      }if(this.payinfo == 'Applicant ID Amount'){ 

         this.app.ID_Transaction_Id = this.transid;
        this.app.ID_Payment_Date = this.paydate;
        this.paymentStatusIDamount = this.paymentStatus;
        

      }
          if (
        localStorage.getItem('applicationFeePaid') === 'true' ||
        localStorage.getItem('idAmountPaid') === 'true'
    ) {
        this.addBeforeUnloadProtection();
    }

      
    this.GetByIdVerify(this.responseData);
    this.GetRelations();
    this.getCategoryforform();
    this.GetAllDistrict();
    this.GetAllDistrictforcoApplicant();
    this.GetAllDistrictforcoApplicantpermanent();
    this.GetAllDistrictforcoApplicantcorrespondence();
    this.GetAllDistrictforApplicant();
    this.GetProjectDetailsforapplication();
    this.GetAllBanksforapplication();
  }
  // toggleCoApplicantFields() {
  //   if (!this.terms) {
  //     this.APP_SA_Name = '';
  //     this.coApplicantNameHindi = '';
  //     this.co_Village_Mohalla = '';
  //     this.co_Police_Station = '';
  //     this.APP_Secondary_Affidavit = '';
  //     this.Co_Pancard = '';
  //     this.APP_SA_DOB = '';
  //     this.APP_SA_Age = '';
  //     this.manifesto_sig_sec = '';
  //   }
  // }

  toUpperCase(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
  }
  getCategoryforform() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getCategoryforform();
    this.data.subscribe(
      (response: any) => {
        this.Categories = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

   checkPopupPermission() {
  const popup = window.open('', '_blank', 'width=100,height=100');

  if (!popup || popup.closed || typeof popup.closed === 'undefined') {
    alert('⚠️ Please allow pop-ups for this site to complete your payment process.');
  } else {
    popup.close();
  }
}

  GetBankDetailsBasedonNotificaton(NO_Id, PD_Id, CA_Id) {
    // debugger;

    this.CA_Id_Fk = CA_Id;

    this.NO_Id = NO_Id;
    this.PD_Id = PD_Id;

    document.getElementById('loader-spinner').style.display = "block";
    this.data1 = this.userService.GetBankDetailsBasedonNotificaton(NO_Id, PD_Id, CA_Id);
    this.data1.subscribe(
      (response: any) => {
        this.data1 = response;
        this.getCategoryname(NO_Id, PD_Id, CA_Id);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  GetAllBranch(DSWOId_NOBD_Bank_Id_FK) {

    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getbranchfrombank(DSWOId_NOBD_Bank_Id_FK);
    this.data.subscribe(
      (response: any) => {
        this.branch = response;

        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
    this.getCategoryname(this.NO_Id, this.PD_Id, this.CA_Id_Fk);
  }

  GetAllBanksforapplication() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllBanksforapplication();
    this.data.subscribe(
      (response: any) => {
        this.Banks = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  getCategoryname(NO_Id, PD_Id, CA_Id) {

    this.DSWOId_NORF_ID_Amount = null;
    this.DSWOId_NORF_Amount = null;
    this.CA_Id_Fk = CA_Id;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getCategoryname(NO_Id, PD_Id, CA_Id);
    this.data.subscribe(
      (response: any) => {
        this.data = response;
        this.DSWOId_NORF_Amount = this.data.DSWOId_NORF_Amount;
        this.DSWOId_NORF_ID_Amount = this.data.DSWOId_NORF_ID_Amount;
        // this.GetBankDetailsBasedonNotificaton(NO_Id,PD_Id,CA_Id);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  GetAllDistrictforcoApplicant() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllDistrictNameforcoApplicant();
    this.data.subscribe(
      (response: any) => {
        this.District = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  GetAllDistrictforApplicant() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllDistrictNameforApplicant();
    this.data.subscribe(
      (response: any) => {
        this.listDistrict = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  GetAllDistrictforcoApplicantpermanent() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllDistrictNameforcoApplicantpermanent();
    this.data.subscribe(
      (response: any) => {
        this.Districtlist = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  GetAllDistrictforcoApplicantcorrespondence() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllDistrictNameforcoApplicantcorrespondence();
    this.data.subscribe(
      (response: any) => {
        this.Districtlists = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  GetAllDistrict() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllDistrictNameforform();
    this.data.subscribe(
      (response: any) => {
        this.Districts = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  GetByIdVerify(mobileNo: any) {
    //debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetByIdverification(mobileNo,this.id,this.pdId);
    this.data.subscribe(
      (response: any) => {
        this.r = response;

if (this.r.CA_id_fk === 18) {
  this.isCasteRequired = false; // make it optional
} else {
  this.isCasteRequired = true;  // mandatory
}
        if (this.r.Payment_Mode === 'CC') {
          this.r.Payment_Mode = 'Credit Card';  // ✅ assignment
        }

        if (this.r.Payment_Mode === 'DC') {
          this.r.Payment_Mode = 'Debit Card';   // ✅ assignment
        }
        if (this.r.Payment_Method == 'Online') {
          this.r.submitteddate = this.r.Online_Payment_Date
        }
        if (this.r.Payment_Method == 'Challan') {
          this.r.submitteddate = this.r.Challan_Payment_Date
        }


        // if (this.r.Date_Of_Birth != null) {
        //   const dateObj = new Date(this.r.Date_Of_Birth);
        //   this.r.Date_Of_Birth = `${('0' + dateObj.getDate()).slice(-2)}/${('0' + (dateObj.getMonth() + 1)).slice(-2)}/${dateObj.getFullYear()}`;
        // }
        // if (this.r.Submitted_Date != null) {
        //   const dateObj = new Date(this.r.Submitted_Date);
        //   this.r.Submitted_Date = `${('0' + dateObj.getDate()).slice(-2)}/${('0' + (dateObj.getMonth() + 1)).slice(-2)}/${dateObj.getFullYear()}`;
        // }
        // this.CalculateAge(this.app.Date_Of_Birth, this.NO_Date);
        // this.CalculateCoapplicantAge(this.app.APP_SA_DOB, this.NO_Date);
        //console.log('verify data: ' + this.r.Applicant_Name + this.r.Payment_Mode );
        document.getElementById('loader-spinner').style.display = "none";
      },
      (error) => {
        console.error(error);
        document.getElementById('loader-spinner').style.display = "none";
      }
    );
  }

  copyPermanentAddress(checked: boolean) {
    if (checked) {
      this.app.APP_VI_Name = this.r.Village_Mohalla;
      this.app.Post_office_Co = this.r.Post_Office;
      this.app.Police_Station_Co = this.r.Police_Station;
      this.app.APP_DI_Id_FK = this.r.District_Id_Fk;
      this.app.APP_Pincode = this.r.Pincode;
    } else {
      this.app.APP_VI_Name = '';
      this.app.Post_office_Co = '';
      this.app.Police_Station_Co = '';
      this.app.APP_DI_Id_FK = '';
      this.app.APP_Pincode = '';
    }
  }
  copyCoApplicantPermanentAddress(checked: boolean) {
    if (checked) {
      this.app.Sec_APP_Village_Co = this.app.Sec_APP_Village_PERM;
      this.app.Sec_APP_Post_Office_Co = this.app.Sec_APP_Post_Office_PERM;
      this.app.Sec_App_Police_Station_Co = this.app.Sec_App_Police_Station_PERM;
      this.app.Sec_APP_District_Fk_Co = this.app.Sec_APP_District_Fk_PERM;
      this.app.Sec_APP_Zipcode_Co = this.app.Sec_APP_Zipcode_PERM;
    } else {
      this.app.Sec_APP_Village_Co = '';
      this.app.Sec_APP_Post_Office_Co = '';
      this.app.Sec_App_Police_Station_Co = '';
      this.app.Sec_APP_District_Fk_Co = '';
      this.app.Sec_APP_Zipcode_Co = '';
    }
  }
  GetRelations() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getRelationsforapplicant();
    this.data.subscribe(
      (response: any) => {
        this.Relations = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  // CalculateAge(dateOfBirth: string, NO_Date): void {
  //   // Extract the date part from the ISO string

  //   // this.PD.NO_Date = NO_Date;
  //   const formattedDateOfBirth = dateOfBirth.split('T')[0];
  //   const formattedNotificationDate = this.PD.NO_Date.split('T')[0];
  //   this.data = this.userService.calculateAgeforApplication(formattedDateOfBirth, formattedNotificationDate);
  //   this.data.subscribe(
  //     (response: any) => {
  //       if (response >= 18) {
  //         this.APP_PA_Age = response;
  //       } else {
  //         swal('Warning!', 'Your Age is less than 18 years.', 'warning');
  //         this.r.Date_Of_Birth = null;
  //         this.APP_PA_Age = null;
  //       }
  //       document.getElementById('loader-spinner').style.display = 'none';
  //     },
  //     (error) => {
  //       document.getElementById('loader-spinner').style.display = 'none';
  //       console.error('Error fetching age:', error);
  //     }
  //   );
  //   this.getCategoryname(this.NO_Id, this.PD_Id, this.CA_Id_Fk);
  // }
  // CalculateCoapplicantAge(dateOfBirth, NO_Date) {
  //   const formattedDateOfBirth = dateOfBirth.split('T')[0];
  //   const formattedNotificationDate = this.PD.NO_Date.split('T')[0];
  //   this.data = this.userService.calculateAgeforCoApplication(formattedDateOfBirth, formattedNotificationDate);
  //   this.data.subscribe(
  //     (response: any) => {
  //       if (response >= 18)
  //         this.APP_SA_Age = response;
  //       else {
  //         swal('Warning!', "Age cannot be less than 18 years to apply", 'warning');
  //         this.app.APP_SA_DOB = null;
  //         this.APP_SA_Age = null;
  //       }
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //     });
  // }


  LandAcquisationFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;

      // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
      let regex = /^[^\\/]+\.pdf$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.LandAcquisation_CertificateErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_LA_Certificate');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_LA_Certificate');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getLandAcquisationFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_LA_Certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  CasteFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
      // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
      let regex = /^[^\\/]+\.pdf$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        //  this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.Caste_CertificateErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_Caste_Certificate');
          i.value = "";
          if (error.status == 400) {
            //   this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Caste_Certificate');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getCasteFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_Caste_Certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  DepositFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
      // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
      let regex = /^[^\\/]+\.pdf$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.APP_POD_CertificateErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_POD_Certificate');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_POD_Certificate');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getDepositFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_POD_Certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  ExServicemanFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
    // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
    let regex = /^[^\\/]+\.pdf$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.APP_Exserviceman_CertificateErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_Exserviceman_Certificate');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Exserviceman_Certificate');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getExServicemanFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_Exserviceman_Certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  IncomecertificateFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
    // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
     let regex = /^[^\\/]+\.pdf$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.APP_Income_CertificateErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_Income_Certificate');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Income_Certificate');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getIncomecertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_Income_Certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  DisabilitycertificateFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
    //  let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
     let regex = /^[^\\/]+\.pdf$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.APP_Disability_CertificateErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_Disability_Certificate');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Disability_Certificate');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getDisabilitycertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_Disability_Certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  ApplicantAffidavitcertificateFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
      // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
        let regex = /^[^\\/]+\.pdf$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.APP_Affidavit_CertificateErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_Affidavit_Certificate');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Affidavit_Certificate');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getApplicantAffidavitcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_Affidavit_Certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  CoApplicantAffidavitcertificateFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
      // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
      let regex = /^[^\\/]+\.pdf$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.APP_Secondary_AffidavitErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_Secondary_Affidavit');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Secondary_Affidavit');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getCoApplicantAffidavitcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_Secondary_Affidavit');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  VoteridcertificateFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
    //  let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
    let regex = /^[^\\/]+\.pdf$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.VoterCardErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('VoterCard');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('VoterCard');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getVoterCardcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('VoterCard');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  CoApplicantPhotographcertificateFileInput(file: FileList) {
// let regex = /^([a-zA-Z0-9\s_\.\-\:\(\)\\])+(\.jpeg|\.jpg|\.png|\.pdf)$/i;
//  let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
 let regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(\.jpeg|\.jpg)$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.APP_SA_PhotoErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_SA_Photo');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_SA_Photo');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload a  image file with extension .jpg", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getCoApplicantPhotographcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_SA_Photo');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  ApplicantPhotographcertificateFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(\.jpeg|\.jpg)$/i;
    // let regex = /^([a-zA-Z0-9\s_\.\-\:\(\)\\])+(\.jpeg|\.jpg|\.png|\.pdf)$/i;
//  let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
let regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;



    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.APP_PA_PhotoErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_PA_Photo');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_PA_Photo');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload a  image file with extension .jpg", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getApplicantPhotographcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_PA_Photo');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  CoApplicantSignaturecertificateFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(\.jpeg|\.jpg)$/i;
  //  let regex = /^([a-zA-Z0-9\s_\.\-\:\(\)\\])+(\.jpeg|\.jpg|\.png|\.pdf)$/i;
//  let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
 let regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.APP_SA_SignatureErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_SA_Signature');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_SA_Signature');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload a  image file with extension .jpg", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getCoApplicantSignaturecertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_SA_Signature');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  AadharcardcertificateFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
      // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
      let regex = /^[^\\/]+\.pdf$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.APP_PA_AdharCardErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_PA_AdharCard');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_PA_AdharCard');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getAadharcardcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_PA_AdharCard');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }


  BankPassbookcertificateFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    // let regex = /^([a-zA-Z0-9\s_\-:\\.]+)\.(pdf|pdef)$/i;
    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
      // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
       let regex = /^[^\\/]+\.pdf$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.bank_passbookErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('bank_passbook');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('bank_passbook');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getBankPassbookcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('bank_passbook');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  PANcertificateFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    // let regex = /^([a-zA-Z0-9\s_\-:\\.]+)\.(pdf|pdef)$/i;
    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
    //  let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
        let regex = /^[^\\/]+\.pdf$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.APP_PA_PanCardErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_PA_PanCard');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_PA_PanCard');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getPANcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_PA_PanCard');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  ResidentialcertificateFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    // let regex = /^([a-zA-Z0-9\s_\-:\\.]+)\.(pdf|pdef)$/i;

    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;

      // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
       let regex = /^[^\\/]+\.pdf$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.APP_Resident_certificateErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_Resident_certificate');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Resident_certificate');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getResidentialcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_Resident_certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  SignatureoftheapplicantFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(\.jpeg|\.jpg)$/i;
  // let regex = /^([a-zA-Z0-9\s_\.\-\:\(\)\\])+(\.jpeg|\.jpg|\.png|\.pdf)$/i;
  //  let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  let regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.APP_PA_SignatureErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('APP_PA_Signature');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_PA_Signature');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload a image file with extension  .jpg", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getSignatureoftheapplicantFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_PA_Signature');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  ManifestoSignatureoftheapplicantFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    // let regex = /^([a-zA-Z0-9\s_\-:\\.]+)\.(pdf|pdef)$/i;
      //  let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
      let regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.manifesto_sigErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('manifesto_sig');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('manifesto_sig');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .jpg", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getManifestoSignatureoftheapplicantFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('manifesto_sig');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  ManifestoSignatureoftheCoapplicantFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    // let regex = /^([a-zA-Z0-9\s_\-:\\.]+)\.(pdf|pdef)$/i;

    // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
      let regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.manifesto_sig_secErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('manifesto_sig_sec');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('manifesto_sig_sec');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .jpg", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getManifestoSignatureoftheCoapplicantFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('manifesto_sig_sec');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  AffidavitFileInput(file: FileList) {

    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    // let regex = /^([a-zA-Z0-9\s_\-:\\.]+)\.(pdf|pdef)$/i;
    //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
      // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
       let regex = /^[^\\/]+\.pdf$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.app.AffidavitErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('Affidavit');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('Affidavit');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getAffidavitFileInputFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('Affidavit');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }


   beforeUnloadHandler = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  event.returnValue = ''; // Standard way to show browser alert on close.
};

addBeforeUnloadProtection() {
  window.addEventListener('beforeunload', this.beforeUnloadHandler);
}

removeBeforeUnloadProtection() {
  window.removeEventListener('beforeunload', this.beforeUnloadHandler);
}







  SaveApplication(ApplicationForm: NgForm) {
    // debugger;
    console.log(JSON.stringify(ApplicationForm.value));
    

    const defaultDate = new Date('1900-01-01T00:00:00');
    const challanPaymentDate = this.r.Challan_Payment_Date ? new Date(this.r.Challan_Payment_Date) : defaultDate;
    const onlinePaymentDate = this.r.Online_Payment_Date ? new Date(this.r.Online_Payment_Date) : null;

    // Determine APP_Payment_Trans_Date based on the given logic
    ApplicationForm.value.APP_Payment_Trans_Date = (challanPaymentDate.getTime() === defaultDate.getTime())
      ? onlinePaymentDate
      : challanPaymentDate;


    ApplicationForm.value.APP_Resident_certificate = this.getResidentialcertificateFileInput();
    ApplicationForm.value.APP_PA_PanCard = this.getPANcertificateFileInput();
    ApplicationForm.value.APP_PA_AdharCard = this.getAadharcardcertificateFileInput();
    ApplicationForm.value.bank_passbook = this.getBankPassbookcertificateFileInput();
    ApplicationForm.value.APP_SA_Signature = this.getCoApplicantSignaturecertificateFileInput();
    ApplicationForm.value.APP_SA_Photo = this.getCoApplicantPhotographcertificateFileInput();
    ApplicationForm.value.APP_Secondary_Affidavit = this.getCoApplicantAffidavitcertificateFileInput();
    ApplicationForm.value.VoterCard = this.getVoterCardcertificateFileInput();
    ApplicationForm.value.APP_Affidavit_Certificate = this.getApplicantAffidavitcertificateFileInput();
    ApplicationForm.value.APP_Disability_Certificate = this.getDisabilitycertificateFileInput();
    ApplicationForm.value.APP_Income_Certificate = this.getIncomecertificateFileInput();
    ApplicationForm.value.APP_Exserviceman_Certificate = this.getExServicemanFileInput();
    ApplicationForm.value.APP_POD_Certificate = this.getDepositFileInput();
    ApplicationForm.value.APP_Caste_Certificate = this.getCasteFileInput();
    ApplicationForm.value.APP_LA_Certificate = this.getLandAcquisationFileInput();
    ApplicationForm.value.APP_PA_Signature = this.getSignatureoftheapplicantFileInput();
    ApplicationForm.value.APP_PA_Photo = this.getApplicantPhotographcertificateFileInput();
    ApplicationForm.value.manifesto_sig = this.getManifestoSignatureoftheapplicantFileInput();
    ApplicationForm.value.manifesto_sig_sec = this.getManifestoSignatureoftheCoapplicantFileInput();
    ApplicationForm.value.Affidavit = this.getAffidavitFileInputFileInput();
    ApplicationForm.value.APP_Project_Id_FK = this.PD.PD_Id;
    ApplicationForm.value.APP_Not_Id_Fk = this.PD.NO_Id;
    ApplicationForm.value.APP_DI_Id_FK = this.r.District_Id_Fk;
    ApplicationForm.value.APP_PA_MobileNo = this.r.Mobile_No;
    ApplicationForm.value.APP_UserId_Fk = this.r.APP_Userid_FK;
    ApplicationForm.value.APP_Reg_No = this.r.APP_REG_NO;
    ApplicationForm.value.Gender = this.r.Gender;
    ApplicationForm.value.APP_Pincode = this.r.Pincode;
    ApplicationForm.value.Email_Address = this.r.Email;
    ApplicationForm.value.APP_Reservation_Id_FK = this.r.CA_id_fk;
    ApplicationForm.value.Aadhar_No = this.r.Aadhar_No; 
    ApplicationForm.value.APP_VI_Name_PERM = this.r.Village_Mohalla;
    ApplicationForm.value.Post_Office_PERM = this.r.Post_Office;
    ApplicationForm.value.Police_Station_PERM = this.r.Police_Station;
    ApplicationForm.value.APP_DI_Id_FK_PERM = this.r.District_Id_Fk;
    ApplicationForm.value.APP_Pincode_PERM = this.r.Pincode;
    ApplicationForm.value.APP_PropertyType = this.NotificationPropertyType;
    ApplicationForm.value.APP_PA_Age = this.APP_PA_Age;
    ApplicationForm.value.APP_SA_Age = this.APP_SA_Age;
    ApplicationForm.value.PAmount = this.r.Paid_Amount;
    ApplicationForm.value.BankChallan_No = this.r.Transaction_Id;
    //ApplicationForm.value.Date_Of_Birth =  this.r.Date_Of_Birth;
    //ApplicationForm.value.Submitted_Date =  this.r.Submitted_Date;
    ApplicationForm.value.Appfee_payment_Method = this.app.Appfee_payment_Method; //new
    ApplicationForm.value.ID_payment_Method = this.app.ID_payment_Method;//new
    ApplicationForm.value.ID_Paid_Amount = this.data.DSWOId_NORF_ID_Amount;
    ApplicationForm.value.Appfee_Paid_Amount = this.data.DSWOId_NORF_Amount;
    ApplicationForm.value.ID_Bank_Name = this.app.ID_Bank_Name;
    ApplicationForm.value.ID_branch = this.app.ID_branch;
    ApplicationForm.value.Appfee_branch = this.app.Appfee_branch;
    ApplicationForm.value.Appfee_Bank_Name = this.app.Appfee_Bank_Name;
    ApplicationForm.value.Appfee_Payment_Date =  this.app.Appfee_Payment_Date;
    ApplicationForm.value.ID_Payment_Date = this.app.ID_Payment_Date;
    ApplicationForm.value.Payment_Mode = this.r.Payment_Mode;
    ApplicationForm.value.Bank_Branch = this.r.Branch;
    ApplicationForm.value.Bank_Name = this.r.Bank_Name
    // this.formInvalid = false;
    // document.getElementById('loader-spinner').style.display = "block";
    // ApplicationForm.value.APP_Project_Id_FK = this.PD_Id;
    Object.keys(ApplicationForm.controls).forEach(key => {
      const control = ApplicationForm.controls[key];
      if (control.invalid) {
        console.log(`Invalid Field: ${key}, Errors:`, control.errors);
      }
    });
    if (ApplicationForm.invalid) {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }
    else {
      this.data = this.userService.PostApplication(ApplicationForm.value);
      this.data.subscribe(
        (response) => {
          console.log(response.ApplicationForm);
          ApplicationForm.reset();
          ApplicationForm.resetForm();
          this.formInvalid = false;

          if (response.Result === "Invalid Transaction Id for Application Fees") {
            swal('Warning!', response.Result, 'warning')
          }

          if (response.Result === "Invalid Transaction Id for Initial Deposit") {
            swal('Warning!', response.Result, 'warning')
          }

          if (response.Result === "Applicant already applied for this notification") {
            swal('Warning!', response.Result, 'warning')
          }
          else {
            swal('Success!', 'Application No.' + response.Result + ' details has been saved successfully.', 'success');
            localStorage.removeItem('applicationFeePaid');
            localStorage.removeItem('idAmountPaid');
            this.removeBeforeUnloadProtection();
            this.router.navigate(
  ['/appform-payment-summary'],
  { queryParams: { appNo: response.Result} }
);
            // this.router.navigate(['applicant-login']);
          }

          document.getElementById('loader-spinner').style.display = "none";

          //this.router.navigate(['home/applicant/applicantview/',this.APP_Id]);
          // window.location.href(='home/applicantview/';
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
          else {
            swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
            this.formInvalid = true;
          }
        });
    }


  }
  onCategoryChange(): void {
    // debugger;
    // Check if a category has been selected
    if (this.app.CA_Id_Fk) {
      // Set APP_AnnualIncome to the value of the selected category ID
      this.app.APP_AnnualIncome = this.app.CA_Id_Fk;

      // Disable all radio buttons
      this.disableRadioButtons();
    } else {
      // If no category is selected, reset APP_AnnualIncome and enable all radio buttons
      this.app.APP_AnnualIncome = undefined;
      this.enableAllRadioButtons();
    }
  }

  // This method disables all radio buttons except the selected one
  disableRadioButtons() {
    const radioButtons = Array.from(
      document.querySelectorAll('input[type="radio"][name="APP_AnnualIncome"]')
    ) as HTMLInputElement[];

    radioButtons.forEach((radio) => {
      radio.disabled = true;
    });

    const selectedRadio = document.querySelector(
      `input[type="radio"][value="${this.app.APP_AnnualIncome}"]`
    ) as HTMLInputElement | null;
    if (selectedRadio) {
      selectedRadio.disabled = false;
    }
  }

  enableAllRadioButtons() {
    const radioButtons = Array.from(
      document.querySelectorAll('input[type="radio"][name="APP_AnnualIncome"]')
    ) as HTMLInputElement[];

    radioButtons.forEach((radio) => {
      radio.disabled = false;
    });
  }



  GetProjectDetailsforapplication() {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getProjectDetailsforApplication(this.id, this.pdId);
    this.data.subscribe(
      (response: any) => {
        this.PD = response;
        if (this.PD.DSWOId_NORF_Sites!= 0)
        {
          this.NotificationPropertyType = 'Plot';
        }
        else if (this.PD.DSWOId_NORF_Houses!= 0){
          this.NotificationPropertyType = 'House';
        }
        else if (this.PD.DSWOld_NORF_Flat!= 0){
          this.NotificationPropertyType = 'Flat';
        }

        
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }


  payment() {
     if (this.hasClickedPay) return;
     //this.checkPopupPermission();

  this.hasClickedPay = true; // Disable button on first click
    //saheb
    //debugger;
    //this.getCategoryname(this.NO_Id,this.PD_Id,this.CA_Id_Fk);

    //this.ApplicationForm.value.ID_Paid_Amount = this.data.DSWOId_NORF_ID_Amount;
    // this.ApplicationForm.value.Appfee_Paid_Amount = this.DSWOId_NORF_Amount ;
    /*
    if (!this.registerForm || !this.registerForm.form) {
      alert("Form not initialized.");
      return;
    }
 
    if (!this.registerForm.valid) {
      console.warn("Form is invalid.");
      return;
    }
    */

    //console.log('registerForm object:', this.registerForm);
    //console.log('registerForm.value:', this.registerForm.value);

    // Find the district object by ID
    // const selectedDistrict = this.Districts.find(
    //   d => Number(d.DI_Id) === Number(this.ApplicationForm.value.District_Id_Fk)
    // );

    // console.log('selected dirst name :', selectedDistrict.DI_District);
    // let fullDistrictName = selectedDistrict.DI_District;  // "Bhagalpur(भागलपुर)"
    let englishDistrictName = this.ApplicationForm.value.DI_District.split('(')[0].trim();
    console.log('english dirst name :', englishDistrictName);

    this.pay_formData = this.ApplicationForm.value;

    //  let firstname1= this.registerForm.value.Applicant_Name;
    //  let email1= this.registerForm.value.Email;
    // let  phoneno1= this.registerForm.value.Mobile_No;
    // let  amount1="100.00";
    // let  productinfo1= "Customer Registration Fee";
    // let  address1=this.registerForm.value.Village_Mohalla;
    //  let address2= this.registerForm.value.Post_Office;
    //  let city1=englishDistrictName;
    // let  zipcode1= this.registerForm.value.Pincode;

    console.log("Form data inside payment():", JSON.stringify(this.pay_formData));
    const paydata = {
      firstname: this.ApplicationForm.value.Applicant_Name,
      email: this.ApplicationForm.value.Email,
      phoneno: this.ApplicationForm.value.Mobile_No,
      // amount: this.ApplicationForm.value.Appfee_Paid_Amount,
      amount: this.DSWOId_NORF_Amount,
      productinfo: "Applicant-Application-Fee",
      address1: this.ApplicationForm.value.Village_Mohalla,
      address2: this.ApplicationForm.value.Post_Office,
      city: englishDistrictName,
      zipcode: this.ApplicationForm.value.Pincode,

    };
    console.log("requist  payment():", JSON.stringify(paydata));
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.Postpayment(paydata);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
        // registerForm.reset();
        console.log('selected Response :', response);
        this.data = response;
        this.pay_data = this.data.data;
        console.log('pay data :' + this.pay_data);
        this.getCategoryname(this.NO_Id, this.PD_Id, this.CA_Id_Fk);
        // Construct Easebuzz URL
        //for staging 
       const easebuzzUrl = `https://testpay.easebuzz.in/pay/${this.pay_data}`;
       //for live
        // const easebuzzUrl = `https://pay.easebuzz.in/pay/${this.pay_data}`;

        // Open the payment window (can be in a new tab or same tab)
        // window.open(easebuzzUrl, "_blank");  // Opens in a new tab
        //this.getCategoryname(this.NO_Id,this.PD_Id,this.CA_Id_Fk);
        // OR use "_self" to open in the same tab
        // window.open(easebuzzUrl, "_self");
        // this.router.navigate(['/payment-success']);
          const paymentWindow = window.open(easebuzzUrl, "_blank");

      // Poll every 500ms to check if the payment window is closed
      const checkClosed = setInterval(() => {
        if (paymentWindow && paymentWindow.closed) {
          clearInterval(checkClosed);
          this.hasClickedPay = false; // re-enable the button
          console.log("Payment window closed, button re-enabled");
        }
      }, 500);



      },
      (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      }
    );
    // this.DSWOId_NORF_Amount = paydata.amount

  }


  payment2() {
         if (this.hasClickedPayId) return;

  this.hasClickedPayId = true; 
  //    if (this.hasClickedPay) return;

  // this.hasClickedPay = true; // Disable button on first click
    //debugger;
    //saheb
    //  this.getCategoryname(this.NO_Id,this.PD_Id,this.CA_Id_Fk);
    // this.ApplicationForm.value.ID_Paid_Amount = this.DSWOId_NORF_ID_Amount;
    // this.ApplicationForm.value.Appfee_Paid_Amount = this.data.DSWOId_NORF_Amount ;
    /*
    if (!this.registerForm || !this.registerForm.form) {
      alert("Form not initialized.");
      return;
    }
 
    if (!this.registerForm.valid) {
      console.warn("Form is invalid.");
      return;
    }
    */

    //console.log('registerForm object:', this.registerForm);
    //console.log('registerForm.value:', this.registerForm.value);

    // Find the district object by ID
    // const selectedDistrict = this.Districts.find(
    //   d => Number(d.DI_Id) === Number(this.ApplicationForm.value.District_Id_Fk)
    // );

    // console.log('selected dirst name :', selectedDistrict.DI_District);
    // let fullDistrictName = selectedDistrict.DI_District;  // "Bhagalpur(भागलपुर)"
    let englishDistrictName = this.ApplicationForm.value.DI_District.split('(')[0].trim();
    console.log('english dirst name :', englishDistrictName);

    this.pay_formData = this.ApplicationForm.value;

    //  let firstname1= this.registerForm.value.Applicant_Name;
    //  let email1= this.registerForm.value.Email;
    // let  phoneno1= this.registerForm.value.Mobile_No;
    // let  amount1="100.00";
    // let  productinfo1= "Customer Registration Fee";
    // let  address1=this.registerForm.value.Village_Mohalla;
    //  let address2= this.registerForm.value.Post_Office;
    //  let city1=englishDistrictName;
    // let  zipcode1= this.registerForm.value.Pincode;

    console.log("Form data inside payment():", JSON.stringify(this.pay_formData));
    const paydata = {
      firstname: this.ApplicationForm.value.Applicant_Name,
      email: this.ApplicationForm.value.Email,
      phoneno: this.ApplicationForm.value.Mobile_No,
      // amount: this.ApplicationForm.value.ID_Paid_Amount,
      amount: this.DSWOId_NORF_ID_Amount,
      productinfo: "Applicant-ID-Amount",
      address1: this.ApplicationForm.value.Village_Mohalla,
      address2: this.ApplicationForm.value.Post_Office,
      city: englishDistrictName,
      zipcode: this.ApplicationForm.value.Pincode,

    };
    console.log("requist  payment():", JSON.stringify(paydata));
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.Postpayment(paydata);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
        // registerForm.reset();
        console.log('selected Response :', response);
        this.data = response;
        this.pay_data = this.data.data;
        console.log('pay data :' + this.pay_data);
        this.getCategoryname(this.NO_Id, this.PD_Id, this.CA_Id_Fk);
        // Construct Easebuzz URL
        // for staging
        const easebuzzUrl = `https://testpay.easebuzz.in/pay/${this.pay_data}`;
        //for live
        // const easebuzzUrl = `https://pay.easebuzz.in/pay/${this.pay_data}`;

        // Open the payment window (can be in a new tab or same tab)
        // window.open(easebuzzUrl, "_blank");  // Opens in a new tab
        // OR use "_self" to open in the same tab
        // window.open(easebuzzUrl, "_self");
        // this.router.navigate(['/payment-success']);
          const paymentWindow = window.open(easebuzzUrl, "_blank");

      // Poll every 500ms to check if the payment window is closed
      const checkClosed = setInterval(() => {
        if (paymentWindow && paymentWindow.closed) {
          clearInterval(checkClosed);
          this.hasClickedPayId = false; // re-enable the button
          console.log("Payment window closed, button re-enabled");
        }
      }, 500);



      },
      (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      }
    );
  }



    onPaymentModeChangeappfee(mode: string): void {
      // debugger;
  
  if (mode === 'Online') {
    this.app.Appfee_Bank_Name = null;
    this.app.Appfee_branch = null;
    this.app.Appfee_Transaction_Id= null; // Clear Bank Challan Number
    this.app.Appfee_Payment_Date = null;
    
    // this.paidAmount = this.paidAmount
    // this.PCA_InstallmemntNo = this.PCA_InstallmemntNo
  }
}

 
    onPaymentModeChangeIdAmount(mode: string): void {
      // debugger;
  
  if (mode === 'Online') {
    this.app.ID_Bank_Name = null;
    this.app.ID_branch = null;
    this.app.ID_Transaction_Id= null; // Clear Bank Challan Number
    this.app.ID_Payment_Date = null;
    // this.paidAmount = this.paidAmount
    // this.PCA_InstallmemntNo = this.PCA_InstallmemntNo
  }
}




//   isFormValidWithoutTransactionId2(): boolean {
//   if (!this.ApplicationForm || !this.ApplicationForm.value) return false;

//   const formValue = this.ApplicationForm.value;

//   const alwaysExcludedFields = [
//     'Appfee_Transaction_Id',
//     'ID_payment_Method',
//     'ID_Bank_Name',
//     'ID_branch',
//     'ID_Transaction_Id',
//     'ID_Payment_Date',
//     'Payment_Mode',
//     'APP_Landline_No',
//     'APP_LA_Certificate',
//     'APP_PA_AdharCard',
//     'APP_PA_PanCard',
//     'Appfee_Payment_Date',
//     'Appfee_branch',
//     'Appfee_Bank_Name',

//     // Newly added exclusions
//     'APP_SA_Name',
//     'APP_SA_DOB',
//     'APP_SA_Relation_Id_FK',
//     'Co_APP_FS_Village',
//     'Co_APP_FS_Post_Office',
//     'Co_App_FS_Police_Station',
//     'Co_APP_FS_District_Fk',
//     'Co_APP_FS_Zipcode',
//     'APP_SA_Photo',
//     'APP_SA_Signature',
//     'Sec_APP_Village_PERM',
//     'Sec_APP_Post_Office_PERM',
//     'Sec_App_Police_Station_PERM',
//     'Sec_APP_District_Fk_PERM',
//     'Sec_APP_Zipcode_PERM',
//     'Sec_APP_Village_Co',
//     'Sec_APP_Post_Office_Co',
//     'Sec_App_Police_Station_Co',
//     'Sec_APP_District_Fk_Co',
//     'Sec_APP_Zipcode_Co',
//     'APP_Secondary_Affidavit',
//     'APP_SA_PanNo',
//     'manifesto_sig_sec'
//   ];

//   const conditionallyExcludedFields: string[] = [];
// const isCasteRequired = this.r.CA_id_fk !== 18;
// if (!isCasteRequired) {
//   conditionallyExcludedFields.push('APP_Caste_Certificate');
// }
//   // Exclude only if Disability is NOT 'Y'
//   if (this.r.Disability !== 'Y') {
//     conditionallyExcludedFields.push('APP_Disability_Certificate');
//   }

//   // Exclude only if Ex_Servicemen is NOT 'Y'
//   if (this.r.Ex_Servicemen !== 'Y') {
//     conditionallyExcludedFields.push('APP_Exserviceman_Certificate');
//   }

//   if (this.r.Payment_Method == 'Online') {
//     conditionallyExcludedFields.push('Bank_Name');
//   }

//   if (this.r.Payment_Method == 'Challan') {
//     conditionallyExcludedFields.push('Payment_Mode');
//   }

//   const excludedFields = [...alwaysExcludedFields, ...conditionallyExcludedFields];

//   for (const key of Object.keys(formValue)) {
//     if (excludedFields.includes(key)) continue;

//     const value = formValue[key];
//     if (value == null || value == undefined || value.toString().trim() == '') {
//       console.log(`Field "${key}" is empty or invalid:`, value);
//       return false;
//     }
//   }

//   return true;
// }



isFormValidWithoutTransactionId2(): boolean {
  if (!this.ApplicationForm) {
    return false;
  }

  const controls = this.ApplicationForm.controls;

  const alwaysExcludedFields: string[] = [
    'Appfee_Transaction_Id',
    'ID_payment_Method',
    'ID_Bank_Name',
    'ID_branch',
    'ID_Transaction_Id',
    'ID_Payment_Date',
    'Payment_Mode',
    'APP_Landline_No',
    'APP_LA_Certificate',
    'APP_PA_AdharCard',
    'APP_PA_PanCard',
    'Appfee_Payment_Date',
    'Appfee_branch',
    'Appfee_Bank_Name',
    'APP_SA_Name',
    'APP_SA_DOB',
    'APP_SA_Relation_Id_FK',
    'Co_APP_FS_Village',
    'Co_APP_FS_Post_Office',
    'Co_App_FS_Police_Station',
    'Co_APP_FS_District_Fk',
    'Co_APP_FS_Zipcode',
    'APP_SA_Photo',
    'APP_SA_Signature',
    'Sec_APP_Village_PERM',
    'Sec_APP_Post_Office_PERM',
    'Sec_App_Police_Station_PERM',
    'Sec_APP_District_Fk_PERM',
    'Sec_APP_Zipcode_PERM',
    'Sec_APP_Village_Co',
    'Sec_APP_Post_Office_Co',
    'Sec_App_Police_Station_Co',
    'Sec_APP_District_Fk_Co',
    'Sec_APP_Zipcode_Co',
    'APP_Secondary_Affidavit',
    'APP_SA_PanNo',
    'manifesto_sig_sec'
  ];

  const conditionallyExcludedFields: string[] = [];

  if (this.r && this.r.CA_id_fk === 18) {
    conditionallyExcludedFields.push('APP_Caste_Certificate');
  }

  if (!this.r || this.r.Disability !== 'Y') {
    conditionallyExcludedFields.push('APP_Disability_Certificate');
  }

  if (!this.r || this.r.Ex_Servicemen !== 'Y') {
    conditionallyExcludedFields.push('APP_Exserviceman_Certificate');
  }

  if (this.r && this.r.Payment_Method === 'Online') {
    conditionallyExcludedFields.push('Bank_Name');
  }

  if (this.r && this.r.Payment_Method === 'Challan') {
    conditionallyExcludedFields.push('Payment_Mode');
  }

  const excludedFields = alwaysExcludedFields.concat(conditionallyExcludedFields);

  /* -----------------------------
     FULL FORM VALIDATION
  ------------------------------*/
  for (const key in controls) {
    if (!controls.hasOwnProperty(key)) continue;

    const control = controls[key];

    // Skip excluded fields
    if (excludedFields.indexOf(key) !== -1) continue;

    // Skip disabled controls
    if (control.disabled) continue;

    // ❌ If ANY control is invalid → stop
    if (control.invalid) {
      console.error('Invalid field blocking Pay Now:', key, control.errors);
      return false;
    }
  }

  // ✅ ENTIRE form is valid
  return true;
}



//   isFormValidWithoutTransactionId(): boolean {
//     debugger;
//     if (!this.ApplicationForm || !this.ApplicationForm.value) return false;

//     const formValue = this.ApplicationForm.value;

//     const alwaysExcludedFields = [
//       'Appfee_Transaction_Id',
//       'ID_payment_Method',
//       'ID_Bank_Name',
//       'ID_branch',
//       'ID_Transaction_Id',
//       'ID_Payment_Date',
//       'Payment_Mode',
//       'APP_Landline_No',
//       'APP_LA_Certificate',
//       'APP_PA_AdharCard',
//       'APP_PA_PanCard',
//       'Appfee_Payment_Date',
//       'Appfee_branch',
//       'Appfee_Bank_Name','APP_SA_Name','APP_SA_DOB','APP_SA_Relation_Id_FK','Co_APP_FS_Village','Co_APP_FS_Post_Office','Co_App_FS_Police_Station','Co_APP_FS_District_Fk',
//       'Co_APP_FS_Zipcode','APP_SA_Photo','APP_SA_Signature','Sec_APP_Village_PERM','Sec_APP_Post_Office_PERM','Sec_App_Police_Station_PERM','Sec_APP_District_Fk_PERM','Sec_APP_Zipcode_PERM',
//       'Sec_APP_Village_Co','Sec_APP_Post_Office_Co','Sec_App_Police_Station_Co','Sec_APP_District_Fk_Co','Sec_APP_Zipcode_Co','APP_Secondary_Affidavit','APP_SA_PanNo','manifesto_sig_sec'
//     ];

//     const conditionallyExcludedFields: string[] = [];
// const isCasteRequired = this.r.CA_id_fk !== 18;
// if (!isCasteRequired) {
//   conditionallyExcludedFields.push('APP_Caste_Certificate');
// }
//     // Exclude only if Disability is NOT 'Y'
//     if (this.r.Disability !== 'Y') {
//       conditionallyExcludedFields.push('APP_Disability_Certificate');
//     }

//     // Exclude only if Ex_Servicemen is NOT 'Y'
//     if (this.r.Ex_Servicemen !== 'Y') {
//       conditionallyExcludedFields.push('APP_Exserviceman_Certificate',);
//     }

//     if (this.r.Payment_Method == 'Online') {
//       conditionallyExcludedFields.push('Bank_Name');
//     }

//     if (this.r.Payment_Method == 'Challan') {
//       conditionallyExcludedFields.push('Payment_Mode');
//     }





//     const excludedFields = [...alwaysExcludedFields, ...conditionallyExcludedFields];

//     for (const key of Object.keys(formValue)) {
//       if (excludedFields.includes(key)) continue;

//       const value = formValue[key];
//       if (value == null || value == undefined || value.toString().trim() == '') {
//         console.log(`Field "${key}" is empty or invalid:`, value);
//         return false;
//       }
//     }

//     return true;
//   }



isFormValidWithoutTransactionId(): boolean {
  if (!this.ApplicationForm) {
    return false;
  }

  const controls = this.ApplicationForm.controls;
  const excludedFields: string[] = [
    'Appfee_Transaction_Id',
    'ID_payment_Method',
    'ID_Bank_Name',
    'ID_branch',
    'ID_Transaction_Id',
    'ID_Payment_Date',
    'Payment_Mode',
    'APP_Landline_No',
    'APP_LA_Certificate',
    'APP_PA_AdharCard',
    'APP_PA_PanCard',
    'Appfee_Payment_Date',
    'Appfee_branch',
    'Appfee_Bank_Name',
    'APP_SA_Name',
    'APP_SA_DOB',
    'APP_SA_Relation_Id_FK',
    'Co_APP_FS_Village',
    'Co_APP_FS_Post_Office',
    'Co_App_FS_Police_Station',
    'Co_APP_FS_District_Fk',
    'Co_APP_FS_Zipcode',
    'APP_SA_Photo',
    'APP_SA_Signature',
    'Sec_APP_Village_PERM',
    'Sec_APP_Post_Office_PERM',
    'Sec_App_Police_Station_PERM',
    'Sec_APP_District_Fk_PERM',
    'Sec_APP_Zipcode_PERM',
    'Sec_APP_Village_Co',
    'Sec_APP_Post_Office_Co',
    'Sec_App_Police_Station_Co',
    'Sec_APP_District_Fk_Co',
    'Sec_APP_Zipcode_Co',
    'APP_Secondary_Affidavit',
    'APP_SA_PanNo',
    'manifesto_sig_sec'
  ];

  /* -----------------------------
     Conditional exclusions
  ------------------------------*/
  if (this.r && this.r.CA_id_fk === 18) {
    excludedFields.push('APP_Caste_Certificate');
  }

  if (!this.r || this.r.Disability !== 'Y') {
    excludedFields.push('APP_Disability_Certificate');
  }

  if (!this.r || this.r.Ex_Servicemen !== 'Y') {
    excludedFields.push('APP_Exserviceman_Certificate');
  }

  if (this.r && this.r.Payment_Method === 'Online') {
    excludedFields.push('Bank_Name');
  }

  if (this.r && this.r.Payment_Method === 'Challan') {
    excludedFields.push('Payment_Mode');
  }

  /* -----------------------------
     Final validation
  ------------------------------*/
  for (const key in controls) {
    if (!controls.hasOwnProperty(key)) continue;

    const control = controls[key];

    if (excludedFields.indexOf(key) !== -1) continue;
    if (control.disabled) continue;

    // ENTIRE FORM must be valid
    if (control.invalid) {
      console.error('Invalid field:', key, control.errors);
      return false;
    }
  }

  return true;
}

onTransactionIdChange(value: string): void {
  // debugger;
  if (this.paymentStatusIDamount !== 'failure') {
    this.app.ID_Transaction_Id = value;
  }
}
onTransactionIdChangeAPPFEE(value: string): void {
  // debugger;
  if (this.paymentStatusappfee !== 'failure') {
    this.app.Appfee_Transaction_Id = value;
  }
}



  trustedOrigins = [
      //'http://localhost:4200',        // your Angular app origin
     'https://portalbshb.esdinfra.com',

    //'http://localhost:14080',     // your payment API origin
    'https://BSHBAPI.esdinfra.com',

    'https://testpay.easebuzz.in'   // Payment provider domain
  ];

  receivePaymentMessage(event: MessageEvent) {
    //debugger;

    console.log("📬 Received message:", event);


    // if (!this.trustedOrigins.includes(event.origin)) {
    //   console.warn("Blocked origin:", event.origin);
    //   return;
    // }


    //const data = event.data;
    // if(data.productinfo == 'Applicant-Application-Fee') {
    //   if (data && data.txnid && data.status) { 
    //   this.app.Appfee_Transaction_Id = data.txnid;
    //   this.paymentStatusappfee = data.status;
    //   this.app.Appfee_Payment_Date = data.addedon;
    //     console.log("saheb transaction Id :",  this.app.Appfee_Transaction_Id);
    //   console.log("saheb payment Status :", this.paymentStatusappfee);
    //   console.log("saheb Online Payment Date :", this.app.Appfee_Payment_Date);
    //   }
    //     else {
    //   console.warn("⚠️ Received message does not contain expected fields:", data);
    // }
    // }


    //  else if(data.productinfo == 'Applicant-ID-Amount') {
    //   if (data && data.txnid && data.status) { 
    //        this.app.ID_Transaction_Id = data.txnid;
    //       this.paymentStatusIDamount = data.status;
    //       this.app.ID_Payment_Date = data.addedon;

    //     console.log("saheb transaction Id :", this.transactionId);
    //   console.log("saheb payment Status :", this.paymentStatusIDamount);
    //   console.log("saheb Online Payment Date :", this.app.ID_Payment_Date);
    //   }
    //     else {
    //   console.warn("⚠️ Received message does not contain expected fields:", data);
    // }
    // }
   

    const data = event.data || {};
    const { txnid, status, addedon, productinfo } = data;
    if (productinfo === 'Applicant-Application-Fee') {
      if (txnid && status) {
        this.app.Appfee_Transaction_Id = txnid;
        this.paymentStatusappfee = status;
        console.log(this.paymentStatusappfee);
        this.app.Appfee_Payment_Date = addedon || null;

        console.log("saheb transaction Id :", this.app.Appfee_Transaction_Id);
        console.log("saheb payment Status :", this.paymentStatusappfee);
        console.log("saheb Online Payment Date :", this.app.Appfee_Payment_Date);
                if (this.paymentStatusappfee === 'success') {
                localStorage.setItem('applicationFeePaid', 'true');
                this.addBeforeUnloadProtection();
            }
            else if (this.paymentStatusappfee != 'success'){
              this.hasClickedPay = false;
            }
      } else {
        console.warn("⚠️ Received message does not contain expected fields:", data);
        this.hasClickedPay = false;
      }
    }
    else if (productinfo === 'Applicant-ID-Amount') {
      if (txnid && status) {
        this.app.ID_Transaction_Id = txnid;
        this.paymentStatusIDamount = status;
        this.app.ID_Payment_Date = addedon || null;

        console.log("saheb transaction Id :", this.app.ID_Transaction_Id);
        console.log("saheb payment Status :", this.paymentStatusIDamount);
        console.log("saheb Online Payment Date :", this.app.ID_Payment_Date);
           if (this.paymentStatusIDamount === 'success') {
                localStorage.setItem('idAmountPaid', 'true');
                this.addBeforeUnloadProtection();
            }
            else if (this.paymentStatusIDamount != 'success'){
              this.hasClickedPayId = false;
            }
      } else {
        console.warn("⚠️ Received message does not contain expected fields:", data);
        this.hasClickedPayId = false;
      }
    }




      

    // if (data && data.txnid && data.status) {
    //   this.transactionId = data.txnid;
    //   this.paymentStatus = data.status;
    //   this.Online_Payment_Date = data.addedon;
    //   // Show alert or update UI
    //   //alert(`Payment Success!\nTransaction ID: ${this.transactionId}\nStatus: ${this.paymentStatus}`);
    //   console.log("saheb transaction Id :", this.transactionId);
    //   console.log("saheb payment Status :", this.paymentStatus);
    //   console.log("saheb Online Payment Date :", this.Online_Payment_Date);

      // Optionally: enable Save button or auto-submit
        else {
      console.warn("⚠️ Received message does not contain expected fields:", data);
    }
  
    }

    isChallanValid(): boolean {
  if (this.app.Appfee_payment_Method !== 'Challan') return true;

  return (
    this.app.Appfee_Bank_Name &&
    this.app.Appfee_branch &&
    this.app.Appfee_Transaction_Id &&
    this.app.Appfee_Transaction_Id.length === 12 &&
    this.app.Appfee_Payment_Date
  );
}

onCancel() {
  this.app.CA_Id_Fk='';
  this.app.APP_Landline_No='';
  this.app.Date_Of_Birth='';
  this.APP_PA_Age='';
  this.app.APP_PA_Photo='';
  this.app.APP_PA_Signature='';
  this.APP_SA_Name='';
  this.app.APP_SA_DOB='';
  this.APP_SA_Age='';
  this.app.APP_SA_Relation_Id_FK='';
  this.app.APP_FS_Village='';
  this.app.APP_FS_Post_Office='';
  this.app.App_FS_Police_Station='';
  this.app.APP_FS_District_Fk='';
  this.app.APP_FS_Zipcode='';
  this.app.APP_VI_Name='';
  this.app.Post_office_Co='';
  this.app.Police_Station_Co='';
  this.app.APP_DI_Id_FK='';
  this.app.APP_Pincode='';
  this.app.Co_APP_FS_Village='';
  this.app.Co_APP_FS_Post_Office='';
  this.app.Co_App_FS_Police_Station='';
  this.app.Co_APP_FS_District_Fk='';
  this.app.Co_APP_FS_Zipcode='';
  this.app.APP_SA_Photo='';
  this.app.APP_SA_Signature='';
  this.app.Sec_APP_Village_PERM='';
  this.app.Sec_APP_Post_Office_PERM='';
  this.app.Sec_App_Police_Station_PERM='';
  this.app.Sec_APP_District_Fk_PERM='';
  this.app.Sec_APP_Zipcode_PERM='';
  this.app.Sec_APP_Village_Co='';
  this.app.Sec_APP_Post_Office_Co='';
  this.app.Sec_App_Police_Station_Co='';
  this.app.Sec_APP_District_Fk_Co='';
  this.app.Sec_APP_Zipcode_Co='';
  this.app.APP_BankBranch='';
  this.app.branchcode='';
  this.app.APP_IFSC='';
  this.app.APP_AccountNo='';
  this.app.APP_PA_PanNo='';
  this.app.APP_SA_PanNo='';
  this.app.APP_NomineeName='';
  this.app.manifesto='';
  this.app.manifesto_sig='';
  this.app.manifesto_sig_sec='';
  this.app.APP_LA_Certificate='';
  this.app.APP_Caste_Certificate='';
  this.app.APP_PA_AdharCard='';
  this.app.APP_PA_PanCard='';
  this.app.APP_Resident_certificate='';
  this.app.Affidavit='';
  this.app.APP_POD_Certificate='';
  this.app.APP_Income_Certificate='';
  this.app.APP_Affidavit_Certificate='';
this.app.bank_passbook='';
this.app.APP_Exserviceman_Certificate='';
this.app.APP_Disability_Certificate='';
this.app.VoterCard='';
this.app.APP_Secondary_Affidavit='';
this.app.Appfee_Bank_Name='';
this.app.Appfee_branch='';
this.app.Appfee_Transaction_Id='';
this.app.Appfee_Payment_Date='';
this.app.ID_Bank_Name='';
this.app.ID_branch='';
this.app.ID_Transaction_Id='';
this.app.ID_Payment_Date='';
}

  }







// WEBPACK FOOTER //
// ./src/app/registration/form-application/form-application.component.ts